<template>
  <v-data-table
    :items="adsFiltered"
    :headers="headers"
    :loading="loading"
    :custom-sort="customSort"
    item-key="id"
    class="c-data-table c-data-table--alternate"
  >
    <template #item.image="{ item }">
      <div class="d-flex align-center py-2">
        <v-img
          width="60"
          height="60"
          class="flex-grow-0 rounded navy lighten-3"
          :src="getItemThumbnailUrl(item)"
        />
      </div>
    </template>
    <template #item.name="{ item }">
      <div class="d-flex align-center py-2">
        <div class="ml-4">
          <div class="mb-1">{{ item.name }}</div>
          <div v-if="item.status !== 'DRAFT'" class="mx-n2">
            <v-btn
              v-if="getItemStatus(item) === 'ACTIVE'"
              small
              rounded
              text
              color="red"
              :loading="isAdStatusChanging(item)"
              @click="onAdStatusChangeClick(item)"
            >
              <v-icon left>mdi-power-standby</v-icon>
              Vypnout
            </v-btn>
            <v-btn
              v-else
              small
              rounded
              text
              color="green"
              :loading="isAdStatusChanging(item)"
              @click="onAdStatusChangeClick(item)"
            >
              <v-icon left>mdi-power-standby</v-icon>
              Zapnout
            </v-btn>
          </div>
        </div>
      </div>
    </template>

    <template #item.status="{ item }">
      <ui-status-chip :value="getItemStatus(item)" />
    </template>

    <template #item.budget="{ item }">
      <div v-if="getAdBudget(item).budget">
        <div>{{ getAdBudget(item).budget }} Kč</div>
        <div class="body-1 font-weight-medium grey--text">
          {{ getAdBudget(item).type }}
        </div>
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <template #item.spent="item">
      <div v-if="item.item.insights && item.item.insights.data[0].spend">
        <div>
          {{
            Math.round(item.item.insights.data[0].spend).toLocaleString()
          }}&nbsp;Kč
        </div>
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>
    <!--        <template #item.spent="{ item }">-->
    <!--          {{ item.spent.toLocaleString() }}&nbsp;Kč-->
    <!--        </template>-->

    <template #item.schedule="{ item }">
      <div class="d-flex align-center">
        <ui-datetime date time :value="item.adset.startTime" />
        <v-icon small class="mx-1">mdi-arrow-right</v-icon>
        <ui-datetime date time :value="item.adset.endTime" />
      </div>
      <!--          <div class="body-1 font-weight-medium grey&#45;&#45;text" v-text="'31 dní'" />-->
    </template>

    <template #item.cpm="item">
      <div v-if="item.item.insights && item.item.insights.data[0].cpm">
        <div>
          {{
            Math.round(item.item.insights.data[0].cpm).toLocaleString()
          }}&nbsp;Kč
        </div>
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <!--    <template #item.results="{ item }">-->
    <!--      <div v-text="item.results" />-->
    <template #item.unique_clicks="item">
      <div
        v-if="item.item.insights && item.item.insights.data[0].outboundClicks"
      >
        <div>
          {{ Math.round(getUniqueClicks(item.item)).toLocaleString() }}
        </div>
        <div class="body-1 font-weight-medium grey--text" v-text="'kliknutí'" />
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <!--    <template #item.reach="{ item }">-->
    <!--      {{ item.reach.toLocaleString() }}-->
    <template #item.unique_link_clicks_ctr="item">
      <div
        v-if="
          item.item.insights && item.item.insights.data[0].uniqueLinkClicksCtr
        "
      >
        {{
          Math.round(item.item.insights.data[0].uniqueLinkClicksCtr * 100) /
            100
        }}%
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <!--    <template #item.cpr="{ item }">-->
    <!--      <div>{{ item.cpr.toLocaleString() }}&nbsp;Kč</div>-->
    <template #item.cost_per_action_type="item">
      <div
        v-if="
          item.item.insights &&
            item.item.insights.data[0].costPerActionType &&
            getCostPerActionType(item.item)
        "
      >
        <div>
          {{
            Math.round(getCostPerActionType(item.item)).toLocaleString()
          }}&nbsp;Kč
        </div>
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <!--    <template #item.conversion="{ item }">-->
    <!--      <div>{{ item.conversion.toLocaleString() }}&nbsp;%</div>-->
    <template #item.action_values="item">
      <div
        v-if="
          item.item.insights &&
            item.item.insights.data[0].actionValues &&
            getActionValues(item.item)
        "
      >
        <div>
          {{ Math.round(getActionValues(item.item)).toLocaleString() }}&nbsp;Kč
        </div>
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <template #item.website_purchase_roas="item">
      <div
        v-if="
          item.item.insights &&
            item.item.insights.data[0].websitePurchaseRoas &&
            item.item.insights.data[0].websitePurchaseRoas[0]
        "
      >
        {{
          Math.round(
            item.item.insights.data[0].websitePurchaseRoas[0].value * 100
          ) / 100
        }}
      </div>
      <div v-else class="px-4" style="white-space: nowrap">--</div>
    </template>

    <template #item.actions="{ item }">
      <ui-table-actions :actions="getActions(item)" @edit="onEditClick(item)" />
    </template>
  </v-data-table>
</template>

<script>
import { call, get } from "vuex-pathify"
import Toastification from "../Toastification"
import { getAdStatus } from "@/model/entity/Ad"
import { createCustomSort } from "../../../helpers/table"

const commonHeaders = [
  { text: "", value: "image" },
  { text: "Název", value: "name" },
  { text: "Status", value: "status" },
]

const analyticViewHeaders = [
  ...commonHeaders,
  { text: "Cena za 1000 zobrazení", value: "cpm" },
  { text: "Prokliky", value: "unique_clicks" },
  { text: "CTR", value: "unique_link_clicks_ctr" },
  { text: "Cena za proklik", value: "cost_per_action_type" },
  { text: "Obrat", value: "action_values" },
  { text: "ROAS", value: "website_purchase_roas" },
]

const genericViewHeaders = [
  ...commonHeaders,
  { text: "Rozpočet", value: "budget" },
  { text: "Utraceno", value: "spent" },
  { text: "Plán", value: "schedule" },
]

const actionsList = {
  draft: [
    {
      text: "Upravit",
      icon: "mdi-pencil-outline",
      disabled: false,
      emit: "edit",
    },
    {
      text: "Duplikovat",
      icon: "mdi-content-copy",
      iconStyle: { fontSize: "20px" },
      disabled: true,
      emit: "duplicate",
      tooltip: "Duplikování reklam bude přístupné v příští verzi.",
    },
    {
      text: "Smazat",
      icon: "mdi-delete-outline",
      disabled: true,
      iconClass: "red--text",
      textClass: "red--text",
      emit: "delete",
      tooltip: "Mazání reklam bude přístupné v příští verzi.",
    },
  ],
  ad: [
    {
      text: "Upravit",
      icon: "mdi-pencil-outline",
      disabled: true,
      emit: "edit",
      tooltip:
        "Reklamy vytvořené mimo Adveroo budete moci upravovat v příští verzi.",
    },
    {
      text: "Duplikovat",
      icon: "mdi-content-copy",
      iconStyle: { fontSize: "20px" },
      disabled: true,
      emit: "duplicate",
      tooltip:
        "Reklamy vytvořené mimo Adveroo budete moci upravovat v příští verzi.",
    },
    {
      text: "Smazat",
      icon: "mdi-delete-outline",
      disabled: true,
      iconClass: "red--text",
      textClass: "red--text",
      emit: "delete",
      tooltip:
        "Reklamy vytvořené mimo Adveroo budete moci upravovat v příští verzi.",
    },
  ],
}

function getAdBudget(ad) {
  let result = {}

  if (ad.adset.budgetType) {
    // ad draft
    result = {
      budget:
        ad.adset.budgetType === "daily"
          ? ad.adset.dailyBudget
          : ad.adset.lifetimeBudget,
      type: ad.adset.budgetType === "daily" ? "denně" : "celkem",
    }
  } else {
    // regular ad
    const daily = ad.adset.dailyBudget > 0

    result = {
      budget: daily
        ? parseInt(ad.adset.dailyBudget)
        : parseInt(ad.adset.lifetimeBudget),
      type: daily ? "denně" : "celkem",
    }
  }

  result.budget = Math.floor(result.budget / 100)

  return result
}

function getUniqueClicks(ad) {
  if (
    ad.insights &&
    ad.insights.data[0] &&
    ad.insights.data[0].outboundClicks
  ) {
    const outboundClicks =
      ad.insights.data[0].outboundClicks[
        ad.insights.data[0].outboundClicks.findIndex(
          item => item.actionType === "outbound_click"
        )
      ]

    return outboundClicks && outboundClicks.value
  }
}

function getCostPerActionType(ad) {
  if (
    ad.insights &&
    ad.insights.data[0] &&
    ad.insights.data[0].costPerActionType
  ) {
    const costPerActionType =
      ad.insights.data[0].costPerActionType[
        ad.insights.data[0].costPerActionType.findIndex(
          item => item.actionType === "link_click"
        )
      ]

    return costPerActionType && costPerActionType.value
  }
}

function getActionValues(ad) {
  if (ad.insights && ad.insights.data[0] && ad.insights.data[0].actionValues) {
    const actionValues =
      ad.insights.data[0].actionValues[
        ad.insights.data[0].actionValues.findIndex(
          item => item.actionType === "omni_purchase"
        )
      ]

    return actionValues && actionValues.value
  }
}

export default {
  name: "AdsTable",
  props: {
    filter: {
      type: String,
      default: "ALL",
    },
    view: {
      type: String,
      default: "generic",
    },
  },
  computed: {
    ...get("ads", ["ads", "loading"]),

    adsFiltered() {
      return this.ads.filter(ad => {
        if (ad.isPublished) {
          return false
        }
        if (this.filter === "ALL") {
          return true
        }
        if (this.filter === "INACTIVE" && this.getItemStatus(ad) !== "ACTIVE") {
          return true
        }
        return this.filter === this.getItemStatus(ad)
      })
    },

    headers() {
      return [
        ...(this.view === "analytic"
          ? analyticViewHeaders
          : genericViewHeaders),
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
  },
  data() {
    return {
      adStatusChangeLoadingIds: [],
    }
  },
  methods: {
    ...call("ads", ["patchAdStatus"]),
    customSort: createCustomSort({
      budget: {
        type: "number",
        transform: (_, ad) => getAdBudget(ad).budget,
      },
      spent: {
        type: "number",
        transform: (_, ad) => (ad.insights && ad.insights.data[0].spend) || 0,
      },
      schedule: {
        type: "string",
        transform: (_, ad) => ad.adset.startTime,
      },
      cpm: {
        type: "number",
        transform: (_, ad) => ad.insights && ad.insights.data[0].cpm,
      },
      unique_clicks: {
        type: "number",
        transform: (_, ad) => getUniqueClicks(ad) || 0,
      },
      unique_link_clicks_ctr: {
        type: "string",
        transform: (_, ad) =>
          (ad.insights && ad.insights.data[0].uniqueLinkClicksCtr) || 0,
      },
      cost_per_action_type: {
        type: "number",
        transform: (_, ad) => getCostPerActionType(ad) || 0,
      },
      action_values: {
        type: "number",
        transform: (_, ad) => getActionValues(ad) || 0,
      },
      website_purchase_roas: {
        type: "number",
        transform: (_, ad) =>
          (ad.insights &&
            ad.insights.data[0].websitePurchaseRoas &&
            ad.insights.data[0].websitePurchaseRoas[0] &&
            ad.insights.data[0].websitePurchaseRoas[0].value) ||
          0,
      },
    }),

    getActions(item) {
      let result = []

      if (item.status === "DRAFT" || item.adDraftId) {
        result = actionsList["draft"]
      } else {
        result = actionsList["ad"]
      }

      return result
    },

    getItemStatus(item) {
      return getAdStatus(item)
    },

    getItemThumbnailUrl(item) {
      if (item.creative && item.creative.thumbnailUrl) {
        return item.creative.thumbnailUrl
      } else if (item.media) {
        return item.media.url128
      }
    },

    getAdBudget,

    getUniqueClicks,

    getCostPerActionType,

    getActionValues,

    onAdStatusChangeClick(item) {
      this.adStatusChangeLoadingIds.push(item.id)
      this.patchAdStatus(item)
        .catch(error => {
          this.$toast.error({
            component: Toastification,
            props: {
              title: "Nelze změnit stav reklamy",
              text: error.data.exception.message,
            },
          })
        })
        .finally(() => {
          this.adStatusChangeLoadingIds = this.adStatusChangeLoadingIds.filter(
            id => id !== item.id
          )
        })
    },

    isAdStatusChanging(item) {
      return this.adStatusChangeLoadingIds.indexOf(item.id) !== -1
    },

    onDeleteClick(item) {},

    onDuplicateClick(item) {},

    onEditClick(item) {
      let id = null

      if (item.status === "DRAFT") {
        id = item.id
      } else if (item.adDraftId) {
        id = item.adDraftId
      }

      if (id) {
        this.$router.push(`/ads/${id}`)
      }
    },
  },
  // watch: {
  //   viewType(val) {
  //     console.log(val)
  //     this.view = val
  //   }
  // }
}
</script>
